import moment from "moment";
import { urls } from "../constants/app";
import { resetError, setError } from "./errors";
import request from "./utils/request";
import { getDataCursorPaging } from "./reports";

export function fetchInvoices(dataParams = {}) {
    return (dispatch, getState) => {
        const loading = getState().loaders.invoices;
        if (loading) return;
        dispatch({ type: 'SET_LOADER', field: 'invoices', value: true });
        const paging = getState().invoiceforms.paging;
        const sorting = getState().invoiceforms.sorting;
        const filters = getState().invoiceforms.filters;
        const user = getState().user.info;

        if(!filters.endDate) filters.endDate = moment().endOf('day').toDate();
        if(!filters.startDate) filters.startDate = moment().startOf('day').toDate();

        const params = { ...dataParams };

        if (filters.id) {
            dataParams['id'] = filters.id;
            params['id'] = filters.id;
        }

        if (filters.points && filters.points.length > 0) {
            const pointIds = filters.points.map((point) => point.value).filter((item) => item);
            dataParams['point.id_in'] = pointIds;
            params['point.id_in'] = pointIds;
        } else if (filters.point) {
            dataParams['point'] = filters.point;
            params['point'] = filters.point;
        } else if(user.points.length > 0) {
            const pointIds = user.points.map(item => item.id);    
            dataParams['point.id_in'] = pointIds;
            params['point.id_in'] = pointIds;
        }       

        if (filters.payment) {
            dataParams['payment'] = filters.payment;
            params['payment'] = filters.payment;
        } else if (filters.payed) {
            if (filters.payed === 'paymented') {
                dataParams['payment_in'] = ['cash', 'noncash'];
                params['payment_in'] = ['cash', 'noncash'];
            } else {
                dataParams['payment'] = filters.payed;
                params['payment'] = filters.payed;
            }
        }

        if (filters.startDate) {
            const date = moment(filters.startDate).startOf('day').toDate();
            dataParams['date_gte'] = date;
            params['date_gte'] = date;
        }

        if (filters.endDate) {
            const date = moment(filters.endDate).endOf('day').toDate();
            dataParams['date_lte'] = date;
            params['date_lte'] = date;
        }

        if (filters.supplier) {
            dataParams['supplier'] = filters.supplier;
            params['supplier'] = filters.supplier;
        }

        params['_start'] = paging.start;
        params['_limit'] = paging.limit;
        params['_sort'] = `${sorting.field}:${sorting.type}`;

        request({ method: 'get', url: urls.invoiceforms+'/count', params: dataParams })
            .then(result => {
                dispatch({ type: 'SET_INVOICES_COUNT', count: result });
                return;
            })
            .then(async () => {
                return request({ method: 'get', url: urls.invoiceforms, params }).then(async (response) => {
                    dispatch({ type: 'SET_INVOICES', list: response });
                    dispatch({ type: 'SET_LOADER', field: 'invoices', value: false });
                })
            })
            .catch(error => {
                dispatch(setError(error, 'invoices'));
                dispatch({ type: 'SET_LOADER', field: 'invoices', value: false });
            });
    }
}

export function fetchInvoicesExport(dataParams = {}) {
    return async (dispatch, getState) => {
        dispatch({ type: 'SET_LOADER', field: 'invoices', value: true });
        const filters = getState().invoiceforms.filters;
        
        if(!filters.endDate) filters.endDate = moment().endOf('day').toDate();
        if(!filters.startDate) filters.startDate = moment().startOf('day').toDate();

        const params = { ...dataParams };

        if (filters.id) params['id'] = filters.id;

        if (filters.points && filters.points.length > 0) {
            const pointIds = filters.points.map((point) => point.value).filter((item) => item);
            params['point.id_in'] = pointIds;
        } else if (filters.point) {
            params['point'] = filters.point;
        }

        if (filters.payment) {
            dataParams['payment'] = filters.payment;
            params['payment'] = filters.payment;
        } else if (filters.payed) {
            if (filters.payed === 'paymented') {
                dataParams['payment_in'] = ['cash', 'noncash'];
                params['payment_in'] = ['cash', 'noncash'];
            } else {
                dataParams['payment'] = filters.payed;
                params['payment'] = filters.payed;
            }
        }


        if (filters.startDate) {
            const date = moment(filters.startDate).startOf('day').toDate();
            params['date_gte'] = date;
        }

        if (filters.endDate) {
            const date = moment(filters.endDate).endOf('day').toDate();
            params['date_lte'] = date;
        }

        if (filters.supplier) params['supplier'] = filters.supplier;

        params['_sort'] = 'id:asc';

        const list = await getDataCursorPaging(params, {method: 'get', url: `${urls.invoiceforms}`}, true);
        if (list.error) {
            dispatch({ type: 'SET_LOADER', field: 'invoices', value: false });
            dispatch(setError(list.error, 'invoices'));
            return false;
        }

        dispatch({ type: 'SET_LOADER', field: 'invoices', value: false });
        return list;
    }
}


export function deleteInvoice(id) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'invoices', value: true });
    dispatch(resetError('invoices'));
    return request({ method: 'delete', url:`${urls.invoiceforms}/${id}` })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'invoices', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 507 }, 'invoices'));
            dispatch({ type: 'SET_LOADER', field: 'invoices', value: false });
            return false;
        });
    }
}

export function setInvoicesFilters(filters) {
    return dispatch => {
        dispatch({ type: 'SET_INVOICES_FILTERS', filters });
    }
}

export function updateInvoice(id, data) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'invoice', value: true });
    dispatch(resetError('invoices'));
        return request({ method: 'put', url: `${urls.invoiceforms}/${id}`, data: data })
            .then((response) => {
                dispatch({ type: 'SET_INVOICE', detail: response });
                dispatch({ type: 'SET_LOADER', field: 'invoice', value: false });
                dispatch(fetchInvoices());
                return response.number ? response.number : response.id;
            })
            .catch(error => {
                dispatch(setError({ status: 508 }, 'invoices'));
                dispatch({ type: 'SET_LOADER', field: 'invoice', value: false });
                return false;
            });
    
    }
}

export function fetchInvoice(id) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'invoice', value: true });

    return request({ method: 'get', url: `${urls.invoiceforms}/${id}` })
        .then((response) => {
            dispatch({ type: 'SET_INVOICE', detail: response });
            dispatch({ type: 'SET_LOADER', field: 'invoice', value: false });
            return response;
        })
        .catch(error => {
            dispatch(setError(error, 'invoice'));
            dispatch({ type: 'SET_LOADER', field: 'invoice', value: false });
            return null
        });
    }
}

export function setInvoicesPaging(paging) {
    return dispatch => {
        dispatch({ type: 'SET_INVOICES_PAGING', paging });
    }
}

async function updateRawMaterialsPrices(raws) {
    for (const raw of raws) {
        await request({  method: 'put', url: `${urls.rawmaterials}/${raw.id}`, data: { last_price: raw.last_price }});
    }
}

export function createInvoice(data) {
    return async (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'invoice', value: true });
        dispatch(resetError('invoices'));
        
        try {
            if (!data.payment) data.payment = 'none';
            const response = await request({ method: 'post', url: `${urls.invoiceforms}`, data });
            
            dispatch({ type: 'SET_INVOICE', detail: response });
            dispatch({ type: 'SET_LOADER', field: 'invoice', value: false });
            
            const raws = data.rawMaterials.map((raw) => ({ 
                id: raw.id, 
                last_price: raw.price 
            }));
            
            await updateRawMaterialsPrices(raws);
            if (response) dispatch(fetchInvoices());
            return response.number ? response.number : response.id;
        } catch (error) {
            dispatch(setError({ status: 508 }, 'invoices'));
            dispatch({ type: 'SET_LOADER', field: 'invoice', value: false });
            return false;
        }    
    };
}